module.exports = __webpack_public_path__ + "media/images/app/footer/ig-circle-55941402739290fd2000f984189339f3.webp";